module.exports = __webpack_public_path__ + "img/einvoice-issued-filter.12e1c8fa.svg";